import { render, staticRenderFns } from "./ShowSlides.vue?vue&type=template&id=8e13b60c&scoped=true&"
import script from "./ShowSlides.vue?vue&type=script&lang=ts&"
export * from "./ShowSlides.vue?vue&type=script&lang=ts&"
import style0 from "./ShowSlides.vue?vue&type=style&index=0&id=8e13b60c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e13b60c",
  null
  
)

export default component.exports